import { ReactComponent as SvgChevronLeft } from '@img/icons/chevron-left.svg';
import { ReactComponent as SvgChevronRight } from '@img/icons/chevron-right.svg';
import { ReactComponent as SvgPin } from '@img/icons/pin.svg';
import React from 'react';
import S from './FilterList.styles';
const FilterList = ({ professionFilters, countyFilters, servicesFilters, professionValues, postcodeValue, countyValues, servicesValues, title, onApply, onCancel, onClear, onClearPostcode, onPostcodeSearch, onRemove, onSelect, }) => {
    return (React.createElement(S.ItemList, null,
        React.createElement(S.Title, { disabled: !onCancel, onClick: (event) => {
                event.preventDefault();
                onCancel && onCancel();
            } },
            onCancel && React.createElement(SvgChevronLeft, null),
            title),
        React.createElement(S.Item, { onClick: (event) => {
                event.preventDefault();
                onSelect(professionFilters, 'profession');
            } },
            React.createElement("span", null,
                professionFilters.title,
                professionValues && professionValues.length > 0 && (React.createElement("span", null, professionValues.length))),
            React.createElement(S.Arrow, { as: SvgChevronRight })),
        React.createElement(S.Item, { onClick: (event) => {
                event.preventDefault();
                onSelect(countyFilters, 'county');
            } },
            React.createElement("span", null,
                countyFilters.title,
                countyValues && countyValues.length > 0 && React.createElement("span", null, countyValues.length)),
            React.createElement(S.Arrow, { as: SvgChevronRight })),
        React.createElement(S.Item, { onClick: (event) => {
                event.preventDefault();
                onSelect(servicesFilters, 'services');
            } },
            React.createElement("span", null,
                servicesFilters.title,
                servicesValues && servicesValues.length > 0 && React.createElement("span", null, servicesValues.length)),
            React.createElement(S.Arrow, { as: SvgChevronRight })),
        React.createElement(S.Item, { onClick: (event) => {
                event.preventDefault();
                onSelect({ key: '', options: [], title: '' }, 'sortBy');
            } },
            React.createElement("span", null, "Sort by"),
            React.createElement(S.Arrow, { as: SvgChevronRight })),
        React.createElement(S.Item, { "data-postcode": "true" },
            React.createElement(S.PostcodeSearchButton, { onClick: onPostcodeSearch },
                React.createElement(SvgPin, null),
                " ",
                React.createElement("strong", null, "Postcode:"),
                " ",
                postcodeValue ? postcodeValue : 'Search'),
            postcodeValue && (React.createElement(S.ClearFilter, null,
                React.createElement("button", { onClick: () => onClearPostcode(false), title: "Edit" }, postcodeValue),
                React.createElement("button", { onClick: () => onClearPostcode(true), title: "Clear Filter" }, "\u00D7")))),
        onApply && (React.createElement(S.FilterBtns, null,
            React.createElement(S.BtnHolder, null,
                React.createElement(S.ApplyFilters, { title: "Apply Filters", themeOption: "rssGreen", onClick: (event) => {
                        event.preventDefault();
                        onApply && onApply();
                    } })),
            React.createElement(S.BtnHolder, null,
                React.createElement(S.RemoveFilters, { title: "Remove Filters", themeOption: "rssWhiteOutline", onClick: (event) => {
                        event.preventDefault();
                        onRemove && onRemove();
                    } })))),
        onClear && (React.createElement(S.Clear, { onClick: (event) => {
                event.preventDefault();
                onClear();
            } }, "Clear"))));
};
export default FilterList;
